var map = {
	"./1.png": 1199,
	"./10.png": 8703,
	"./11.png": 4598,
	"./2.png": 4151,
	"./3.png": 3110,
	"./4.png": 9051,
	"./5.png": 2375,
	"./6.png": 6250,
	"./7.png": 7695,
	"./8.png": 9307,
	"./9.png": 8967,
	"./back.jpg": 3648,
	"./bg1.png": 3824,
	"./bg2.png": 7913,
	"./bg3.png": 1425,
	"./bg4.png": 5303,
	"./bg5.png": 323,
	"./bg6.png": 6188,
	"./bg7.png": 8681,
	"./blue-figure.svg": 8189,
	"./dark-blue-figure.svg": 3272,
	"./red-figure.svg": 5963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;